import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {
    checkPermission, getDefaultOptionByValue,
    getDOYOptions,
    getGreekCurrencyFormat,
    getOptionsByData,
    isEmpty, quickClone
} from "../../../../../_helpers/commonFunctions";
import {Accordion, Badge, Col, Modal, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../../primer/Dropdown";
import Input from "../../../../common/Input";
import DateBox from "../../../../primer/DateBox";
import EditableTable from "../../../../primer/Editable-Table";
import {
    deleteObjectFromArrayOfObjects,
    fixDocumentTaxesDisplay,
    getLabelByValue
} from "../../../../../_helpers/helperFunctions";
import Button from "react-bootstrap/Button";
import {
    expenseTypes,
    getECCategoryOptions,
    getECTypeOptions,
    getVatExpenseClassificationType, vat39ACategories
} from "../../../../../_helpers/sharedmydata";
import {DISABLED_FIXED_ASSET_CATEGORIES} from "../../FixedAssets/constants";
import {FaExchangeAlt, FaFileInvoice} from "react-icons/fa";
import AdvancedCombobox from "../../../../primer/AdvancedCombobox";
import Alert from "react-bootstrap/esm/Alert";
import {MdCategory, MdOutlineCancel} from "react-icons/md";
import ChangeCategoryModal from "./changeCategoryModal";
import {
    formatPath,
    getFileNameFromPath,
    getMimeType,
    greekMonths,
    popExtension
} from "../../Cloud/Components/constants";
import {RiGeminiFill} from "react-icons/ri";
import {TbReload} from "react-icons/tb";
import AccountingBox from "../../../../primer/AccountingBox";
import moment from "moment";
import {CgDanger} from "react-icons/cg";
import {useTranslation} from "../../../../../hooks/useTranslation";

const AISaveBuyModal = ({show, setShow, aiDoc, onSave, onReprocess, onDecline}) => {
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const aiModuleType = useSelector((state) => state.AI.aiModuleType);

    const advancedTypesBuys = useSelector((state) => state.SETTINGS.settings.advancedTypesBuys);
    const buysGeneralSettings = useSelector((state) => state.BUYS_SETTINGS.buysGeneralSettings);
    const installations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const installationOptions = getOptionsByData(installations, "installationMasterId", "address");
    const [legacyBuy, setLegacyBuy] = useState({});
    const [newBuy, setNewBuy] = useState({});
    const [loadingDraft, setLoadingDraft] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const ecCategory = getECCategoryOptions();
    const ecType = getECTypeOptions();
    const vatExpenseTypes = getVatExpenseClassificationType();

    const has39A = newBuy?.products?.some((el) => el.vatReason === "16");

    const [incrKey, setIncrKey] = useState(0);
    const [productListData, setProductListData] = useState([]);
    const [showChangeCategoryModal, setShowChangeCategoryModal] = useState(false);
    const [showAiThoughtsModal, setShowAiThoughtsModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const [suppliersListData, setSuppliersListData] = useState([]);

    const [percentageAnamorfosis, setPercentageAnamorfosis] = useState(0);

    const [defaultOpenAssets, setDefaultOpenAssets] = useState(false); // Accordion
    const [defaultOpenAnamorfosis, setDefaultOpenAnamorfosis] = useState(false); // Accordion

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [newBuy.products])

    useEffect(() => {
        if (!show) {
            setNewBuy({});
            setLoadingDraft(false);
            setDefaultOpenAssets(false);
            setDefaultOpenAnamorfosis(false);
        } else {
            onShow();
            onProductSearch(null, setProductListData);
        }
    }, [show])

    useEffect(() => {
        if (!isEmpty(newBuy.documentType)) {
            loadSuppliersListData(newBuy.documentType);
        }
    }, [newBuy.documentType]);

    const onShow = () => {
        setLoadingDraft(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                docId: aiDoc.erp_draftDocument,
                section: "Buys",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setNewBuy(res.data.data);
                setLegacyBuy(res.data.data);
                if (res.data.data.products.some((el) => el.autoCreateFixedAsset)) setDefaultOpenAssets(true);
                if (res.data.data.products.some((el) => el.anamorfosisNetValue > 0 || el.anamorfosisVatValue > 0 || el.anamorfosisTaxValue > 0)) setDefaultOpenAnamorfosis(true);
                setLoadingDraft(false);
            } else {
                setShow(false);
                toast.error("Σφάλμα κατά την άντληση εγγραφής.");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση εγγραφής.");
        })
    }

    const loadSuppliersListData = (value) => {
        const data = {
            id: value,
            company: company.id,
            name: ''
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/supplier-list-by-advanced-type-id/${value}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        // Remove none empty supplier name data
                        let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
                        setSuppliersListData([...filteredData]);
                    } else {
                        setSuppliersListData([]);
                    }
                } else {
                    setSuppliersListData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }

    const loadSuppliersListDataOnChange = (value, setData) => {
        let data = {
            id: newBuy.documentType,
            name: value,
            company: company.id
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/supplier-list-by-advanced-type-id/${data.id}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        // Remove none empty supplier name data
                        let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
                        setData(filteredData);
                    } else {
                        setData([]);
                    }
                } else {
                    setData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }
    const onChangeSearch = (keyword, setData) => {
        if (keyword.length >= 2) {
            loadSuppliersListDataOnChange(keyword, setData)
        }
    }

    const getPaymentTypes = () => {
        if (buysGeneralSettings.paymentTypes) {
            return getOptionsByData(buysGeneralSettings.paymentTypes, "_id", "name");
        } else {
            return [];
        }
    }

    const supplierDropdownColumns = [
        {
            label: t("General.code"),
            name: "systemCode",
        },
        {
            label: t("General.supplierName"),
            name: "name",
        },
        {
            label: t("General.phone"),
            name: "phone",
        },
        {
            label: t("General.email"),
            name: "email",
        },
        {
            label: t("General.vatNumber"),
            name: "vatNumber",
        },
    ];

    const getNewBuyDocumentTypes = () => {
        if (advancedTypesBuys) {
            return getOptionsByData(advancedTypesBuys.filter((el) => el.myDataType === aiDoc.myDataType || el?.classificationsArray?.includes(aiDoc.myDataType)), "_id", "name");
        } else {
            return [];
        }
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            if (name === "documentType") {
                prepChange.documentType = e.value;
                prepChange.documentTypeName = e.label;
            } else if (name === "installation") {
                prepChange.installation = e.value;
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).toDate();
            } else {
                prepChange[name] = "";
            }
        } else if (type === 'acdd' && name === "supplier") {
           let sSupplier = e.row;
            prepChange.supplier = sSupplier._id;
            prepChange.supplierName = sSupplier.name;
            prepChange.supplierCode = !isEmpty(sSupplier.manualCode) ? sSupplier.manualCode : sSupplier.systemCode;
            prepChange.address = sSupplier.address;
            prepChange.vat = sSupplier.vatNumber;
            prepChange.doy = getLabelByValue(getDOYOptions(), Number(sSupplier.DOY), 'value');
            prepChange.city = sSupplier.city;
            prepChange.supplierCategoryName = sSupplier?.categoryName;
            prepChange.supplierCategory = sSupplier?.category;
            prepChange.country = sSupplier.country;
            prepChange.pc = sSupplier.postalCode;
            prepChange.email = sSupplier.email;
            prepChange.phone = sSupplier.phone;
            prepChange.activity = sSupplier.activity;
            prepChange.vatCategory = sSupplier.vatCategory;
            prepChange.supplierInstallationType = sSupplier.installations[0]?.type;
            prepChange.supplierInstallationId = sSupplier.installations[0]?.no;
        }
        setNewBuy({...newBuy, ...prepChange});
    }

    const handleUserControlProduct = (rowNumber) => {
        const cloneProducts = quickClone(newBuy.products);
        const p = cloneProducts.find((el) => el.no === rowNumber);
        if (p.userSelected) { // Restore AI selection
            p.userSelected = false;
            const legacyProduct = legacyBuy.products.find((el) => el.no === rowNumber);
            p._id = legacyProduct._id || undefined;
            p.name = legacyProduct.name;
            p.code = legacyProduct.code;
        } else { // Enable user selection
            p.userSelected = true;
            delete p._id;
            p.name = "";
            p.code = "";
        }
        setNewBuy({...newBuy, products: cloneProducts});
    }

    const handleUserSelectProduct = (rowNumber, e) => {
        const cloneProducts = quickClone(newBuy.products);
        const p = cloneProducts.find((el) => el.no === rowNumber);
        p._id = e.row._id;
        p.name = e.row.name;
        p.code = e.row.code;
        setNewBuy({...newBuy, products: cloneProducts});
    }

    const onProductSearch = (keyword, setData) => {
        const reqData = {
            company: company.id,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/category/get-product-list`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const openChangeCategoryModal = (rowData) => {
        setSelectedRowData(rowData);
        setShowChangeCategoryModal(true);
    }

    let productTableColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "2%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Είδος",
            field: "name",
            width: "15%",
            editable: true,
            inputType: {
                type: 'custom-render',
                render: (rowData) => (
                    <React.Fragment>
                        {rowData?.userSelected ? (
                            <React.Fragment>
                                <AdvancedCombobox
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={rowData.name}
                                    data={productListData}
                                    onChange={(e) => handleUserSelectProduct(rowData.no, e)}
                                    excludeColumns={[]}
                                    columns={[
                                        {label: "Κωδικός είδους", name: "code"},
                                        {label: "Όνομα είδους", name: "name"},
                                    ]}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    key={Math.random()}
                                    onChangeSearch={onProductSearch}
                                />
                                <div className={"text-muted text-center"} style={{cursor: "pointer"}} onClick={() => handleUserControlProduct(rowData.no)}><u>Επαναφορά είδους AI</u></div>
                            </React.Fragment>
                        ) : (
                            <div className={"text-center"}>
                                {rowData.name}
                                <Badge bg={"primary"} title={"Αλλαγή είδους"} className={"ml-2"} style={{padding: "4px", cursor: "pointer"}} onClick={() => handleUserControlProduct(rowData.no)}>
                                    <FaExchangeAlt size={16} />
                                </Badge>
                                {isEmpty(rowData._id) && (
                                    <React.Fragment>
                                        <br/>
                                        <Badge bg={"primary"} title={"Αλλαγή κατηγορίας"} className={"ml-1"} style={{padding: "4px", cursor: "pointer"}} onClick={() => openChangeCategoryModal(rowData)}>
                                            <MdCategory size={16} /> {rowData.aiCategory}
                                        </Badge>
                                    </React.Fragment>
                                )}
                            </div>
                        )}
                    </React.Fragment>
                )
            }
        },
        {
            name: "Ποσότητα",
            field: "quantity",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Μον. Μέτρησης",
            field: "muLabel",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Φ.Π.Α. %",
            field: "vatPercentage",
            editable: false,
            width: "5%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Καθαρή Αξία",
            field: "netValue",
            editable: true,
            disabled: true,
            width: "6%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Αξία Φ.Π.Α.",
            field: "vat",
            editable: true,
            disabled: true,
            width: "6%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Τελική Αξία",
            field: "totalValue",
            editable: true,
            disabled: true,
            width: "6%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Κατηγορία MyData",
            field: "classificationCategory",
            editable: true,
            width: "17%",
            inputType: {
                type: 'select',
                options: ecCategory,
            }
        },
        {
            name: "Τύπος MyData",
            field: "classificationType",
            editable: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: ecType,
            }
        },
        {
            name: "Τύπος Εξόδων για Φ.Π.Α.",
            field: "vatExpenseType",
            editable: true,
            disabledCallback: (rowData) => ((has39A && !isEmpty(rowData.vat39a)) || (!(has39A && !isEmpty(rowData.vat39a)) && ["7", "8"].includes(String(rowData.vatId)))),
            width: "13%",
            inputType: {
                type: 'select',
                options: vatExpenseTypes,
            }
        },
        {
            name: "Εκπίπτει Φ.Π.Α.",
            field: "accountingNonDeductibleVAT",
            editable: true,
            width: "4%",
            inputType: {
                type: "checkbox",
            }
        },
        {
            name: "Ενέργειες",
            field: "buttonActions",
            editable: true,
            width: "6%",
            inputType: {
                config: {
                    disabled: false,
                    onClick: (rowData) => {
                        const cloneBuy = quickClone(newBuy);
                        for (const p of cloneBuy.products) {
                            if (p.aiCategory && rowData.aiCategory) p.aiCategory = rowData.aiCategory;
                            p.classificationCategory = rowData.classificationCategory;
                            p.classificationType = rowData.classificationType;
                            if (!(has39A && !isEmpty(p.vat39a)) && !["7", "8"].includes(String(p.vatId))) {
                                p.vatExpenseType = rowData.vatExpenseType;
                                p.accountingNonDeductibleVAT = rowData.accountingNonDeductibleVAT;
                            } else {
                                p.vatExpenseType = "";
                                p.accountingNonDeductibleVAT = "active";
                            }
                        }
                        setNewBuy(cloneBuy);
                    },
                    text: "Όμοιο παντού"
                },
                type: 'button-sm',
            }
        },
    ]

    if (has39A) {
        productTableColumns = [...productTableColumns.map((obj) => {
            return {
                ...obj,
                width: String(parseFloat(obj.width) - 2) + "%",
            }
        }), {
            name: "Φ.Π.Α. Άρθρου 39Α",
            field: "vat39a",
            editable: false,
            editableCallback: (rowData) => has39A && !isEmpty(rowData.vat39a),
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        }, {
            name: "Φ.Π.Α. Άθρ. 39Α %",
            field: "vat39aCategory",
            editable: false,
            editableCallback: (rowData) => has39A && !isEmpty(rowData.vat39a),
            inputType: {
                type: "select",
                options: vat39ACategories,
            }
        }]
    }

    const buysTaxesColumns = [
        {
            name: "Ποσοστό Φ.Π.Α. %",
            field: "vatPercentage",
            editable: false,
        },
        {
            name: "Καθαρή Αξία €",
            field: "netValue",
            editable: false,
        },
        {
            name: "Αξία Φ.Π.Α. €",
            field: "vatEuro",
            editable: false,
        },
        {
            name: "Παρακρατούμενοι Φόροι",
            field: "withholdTaxes",
            editable: false,
        },
        {
            name: "Λοιποί Φόροι",
            field: "otherTaxes",
            editable: false,
        },
        {
            name: "Τέλη",
            field: "fees",
            editable: false,
        },
        {
            name: "Χαρτόσημο (Ψηφ. τέλος συν.)",
            field: "stamp",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            editable: false,
        }
    ];

    const buyAnamorfosisColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "7%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Είδος",
            field: "name",
            editable: false,
            width: "30%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ποσό αναμόρφωσης καθαρής αξίας",
            field: "anamorfosisNetValue",
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Ποσό αναμόρφωσης Φ.Π.Α.",
            field: "anamorfosisVatValue",
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Ποσό αναμόρφωσης Φόρων",
            field: "anamorfosisTaxValue",
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: "Ποσοστό αναμόρφωσης",
            field: "anamorfosiPercent",
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "%",
                    maxLength: 7
                }
            }
        },
        {
            name: "Μόνιμη ποσοστιαία αναμόρφωση είδους",
            field: "permanentAnamorfosi",
            editable: true,
            width: "20%",
            inputType: {
                type: "checkbox",
            }
        },
    ]

    const buyFixedAssetColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "10%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Είδος",
            field: "name",
            editable: false,
            width: "50%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Δημιουργία παγίου",
            field: "autoCreateFixedAsset",
            editable: true,
            width: "15%",
            inputType: {
                type: "checkbox",
            }
        },
        {
            name: "Κατηγορία Παγίου",
            field: "autoCreateFixedAssetCategory",
            editable: true,
            width: "25%",
            disabledCallback: (rowData) => !rowData.autoCreateFixedAsset,
            inputType: {
                type: "select",
                options: DISABLED_FIXED_ASSET_CATEGORIES.map((o) => {
                    return { value: o, label: o }
                })
            }
        },
    ]

    const productTableFunctions = {
        update: (data, id, rowIndex) => {
            let cloneProducts = [...newBuy.products];
            cloneProducts = cloneProducts.map((o) => Object.assign({}, o));
            if (data.classificationCategory) {
                cloneProducts[rowIndex].classificationCategory = data.classificationCategory;
                if(data.classificationCategory === "category2_5" || data.classificationCategory === "category2_95") {
                    cloneProducts[rowIndex].accountingNonDeductibleVAT = "active";
                    cloneProducts[rowIndex].vatExpenseType = "";
                } else if (data.classificationCategory === "category2_4") {
                    cloneProducts[rowIndex].accountingNonDeductibleVAT = "inactive";
                }
            } else if (data.classificationType) {
                cloneProducts[rowIndex].classificationType = data.classificationType;
            } else if (data.vatExpenseType !== undefined) {
                cloneProducts[rowIndex].vatExpenseType = data.vatExpenseType;
            } else if (data.accountingNonDeductibleVAT) {
                if (data.accountingNonDeductibleVAT === "true") {
                    cloneProducts[rowIndex].accountingNonDeductibleVAT = "inactive";
                } else {
                    cloneProducts[rowIndex].accountingNonDeductibleVAT = "active";
                }
            } else if (data.anamorfosisNetValue) {
                let val = +Number(data.anamorfosisNetValue || 0).toFixed(2);
                if (val > cloneProducts[rowIndex].netValue) val = cloneProducts[rowIndex].netValue;
                cloneProducts[rowIndex].anamorfosisNetValue = val;
                cloneProducts[rowIndex].anamorfosiPercent = Number( val / cloneProducts[rowIndex].netValue * 100).toFixed(2);
                cloneProducts[rowIndex].anamorfosisVatValue = +Number((val * (+cloneProducts[rowIndex].vatPercentage / 100)) || 0).toFixed(2);
                cloneProducts[rowIndex].anamorfosisTaxValue = +Number(((val / cloneProducts[rowIndex].netValue) * +cloneProducts[rowIndex].taxes) || 0).toFixed(2);
            } else if (data.anamorfosiPercent) {
                let val = +Number(cloneProducts[rowIndex]?.netValue * data.anamorfosiPercent / 100).toFixed(2);
                if (val > cloneProducts[rowIndex].netValue) val = cloneProducts[rowIndex].netValue;
                cloneProducts[rowIndex].anamorfosisNetValue = val;
                cloneProducts[rowIndex].anamorfosiPercent = Number( val / cloneProducts[rowIndex].netValue * 100).toFixed(2);
                cloneProducts[rowIndex].anamorfosisVatValue = +Number((val * (+cloneProducts[rowIndex].vatPercentage / 100)) || 0).toFixed(2);
                cloneProducts[rowIndex].anamorfosisTaxValue = +Number(((val / cloneProducts[rowIndex].netValue) * +cloneProducts[rowIndex].taxes) || 0).toFixed(2);
            } else if (data.anamorfosisVatValue) {
                let val = +Number(data.anamorfosisVatValue || 0).toFixed(2);
                if (val > cloneProducts[rowIndex].vatValue) val = cloneProducts[rowIndex].vatValue;
                cloneProducts[rowIndex].anamorfosisVatValue = val;
            } else if (data.anamorfosisTaxValue) {
                let val = +Number(data.anamorfosisTaxValue || 0).toFixed(2);
                if (val > +cloneProducts[rowIndex].taxes) val = +cloneProducts[rowIndex].taxes;
                cloneProducts[rowIndex].anamorfosisTaxValue = val;
            } else if (data.autoCreateFixedAsset) {
                cloneProducts[rowIndex].autoCreateFixedAsset = String(data.autoCreateFixedAsset) === "true";
            } else if (data.autoCreateFixedAssetCategory) {
                cloneProducts[rowIndex].autoCreateFixedAssetCategory = data.autoCreateFixedAssetCategory;
            } else if (data.permanentAnamorfosi) {
                cloneProducts[rowIndex].permanentAnamorfosi = String(data.permanentAnamorfosi) === "true";
            }
            setNewBuy({...newBuy, products: cloneProducts});
        },
        selected: () => {},
    }

    const fetchFileAsBlobURL = async (fileName, filePath, attemptConversion = true) => {
        toast.info("Το αρχείο θα ανοίξει σύντομα...");
        try {
            const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
                action: "fetch",
                attemptConversion: String(attemptConversion),
                currentPath: formatPath(filePath),
                company: company.id,
                year: company.year,
            });
            if (fetchResp.data.status === "200") {
                const fromConversion = fetchResp.data.fromConversion;
                const binaryString = atob(fetchResp.data.data);
                const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                let mimeType = getMimeType(fileName);
                if (fromConversion) mimeType = "application/pdf";

                const blob = new Blob([byteArray], { type: mimeType });
                let blobUrl = URL.createObjectURL(blob);
                if (popExtension(fileName) === "pdf" || fromConversion) blobUrl += "#navpanes=0&view=Fit";

                return blobUrl;
            } else {
                return null;
            }
        } catch (err) {
            return null;
        }
    }

    const onFileOpen = async (o) => {
        const blobURL = await fetchFileAsBlobURL(getFileNameFromPath(o.filePath), o.filePath, true);
        if (blobURL) {
            window.open(blobURL, "_blank");
        } else {
            toast.error("Σφάλμα κατά την άντληση αρχείου.");
        }
        setTimeout(() => {
            URL.revokeObjectURL(blobURL);
        }, 1000)
    }

    const disableSeriesAndNumber = !expenseTypes.includes(newBuy.myDataType);

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Καταχώρηση Αγοράς</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingDraft ? (
                        <div style={{textAlign: "center"}}>Γίνεται φόρτωση παρακαλώ περιμένετε...<Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} /></div>
                    ) : Object.keys(newBuy).length > 0 ? (
                        <div>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Dropdown
                                        name={"documentType"}
                                        label={"Τύπος Παραστατικού"}
                                        options={getNewBuyDocumentTypes()}
                                        defaultValue={getNewBuyDocumentTypes().find((el) => el.value === newBuy.documentType) ? getNewBuyDocumentTypes().find((el) => el.value === newBuy.documentType) : ""}
                                        key={Math.random()}
                                        required={true}
                                        onChange={(e) => handleOnChange(e, "dd", "documentType")}
                                    />
                                </Col>
                                <Col sm="12" md="4">
                                    <Dropdown
                                        className={"mb-0"}
                                        label={t("General.installation")}
                                        options={installationOptions}
                                        value={getDefaultOptionByValue(installationOptions, newBuy.installation, 'value', 'label', 'value')}
                                        enabledValue={true}
                                        searchEnable={true}
                                        required={true}
                                        name="installation"
                                        onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"preNumber"}
                                        label={"Σειρά"}
                                        required={true}
                                        value={newBuy.preNumber === "noprefix" ? "Κενή" : newBuy.preNumber}
                                        disabled={disableSeriesAndNumber}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "preNumber")}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"number"}
                                        label={"Αριθμός"}
                                        value={newBuy.number}
                                        required={true}
                                        disabled={disableSeriesAndNumber}
                                        autoComplete={"off"}
                                        type={"number"}
                                        onChange={(e) => handleOnChange(e, "input", "number")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <DateBox
                                        label={"Ημερομηνία"}
                                        name={"date"}
                                        required={true}
                                        selected={new Date(newBuy.date)}
                                        maxDate={new Date()}
                                        onChange={(e) => handleOnChange(e, "datebox", "date")}
                                        disabled={disableSeriesAndNumber}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Input
                                        name={"time"}
                                        label={"Ώρα"}
                                        value={newBuy.time}
                                        disabled={true}
                                        required={true}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                {aiDoc.supplierName === "ΠΡΟΜΗΘΕΥΤΗΣ ΛΙΑΝΙΚΗΣ" ? (
                                    <Col md={6}>
                                        <AdvancedCombobox
                                            ACName="Buys Supplier" // do not change name
                                            className="w-200 ac-select-dropdown"
                                            defaultValue={newBuy.supplierName}
                                            key={Math.random()}
                                            label={t("General.supplier")}
                                            data={suppliersListData}
                                            onChangeSearch={onChangeSearch}
                                            onChange={(e) => handleOnChange(e, 'acdd', 'supplier')}
                                            excludeColumns={[]}
                                            columns={supplierDropdownColumns}
                                            deleteEnable={false}
                                            searchTableEnable={false}
                                            showTableOptionOnSelect={true}
                                            placeholder={t("Placeholders.selectSupplier")}
                                            required={true}
                                            showInsertAddButton={true}
                                            hideSaveButton={true}
                                            hideInsertNewRow={true}
                                            inputFieldClasses="form-control"
                                        />
                                    </Col>
                                ) : (
                                    <Col md={3}>
                                        <Input
                                            name={"name"}
                                            label={"Επωνυμία Προμηθευτή"}
                                            value={newBuy.supplierName}
                                            disabled={true}
                                        />
                                    </Col>
                                )}
                                <Col md={3}>
                                    <Input
                                        name={"vat"}
                                        label={`ΑΦΜ Προμηθευτή`}
                                        value={newBuy.vat}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={aiDoc.supplierName === "ΠΡΟΜΗΘΕΥΤΗΣ ΛΙΑΝΙΚΗΣ" ? 3 : 6}>
                                    <Input
                                        name={"activity"}
                                        label={"Δραστηριότητα"}
                                        value={newBuy.activity}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"address"}
                                        label={"Διεύθυνση"}
                                        value={newBuy.address}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"doy"}
                                        label={"ΔΟΥ"}
                                        value={getDOYOptions().find((el) => String(el.value) === newBuy.doy) ? getDOYOptions().find((el) => String(el.value) === newBuy.doy)?.label : newBuy.doy}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"city"}
                                        label={"Πόλη"}
                                        value={newBuy.city}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"pc"}
                                        label={"Ταχυδρομικός Κωδικός"}
                                        value={newBuy.pc}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Dropdown
                                        name={"paymentType"}
                                        label={"Τρόπος Πληρωμής"}
                                        options={getPaymentTypes()}
                                        defaultValue={getPaymentTypes().find((el) => el.value === newBuy.paymentType) ? getPaymentTypes().find((el) => el.value === newBuy.paymentType) : ""}
                                        key={Math.random()}
                                        disabled={true}
                                    />
                                </Col>
                                {(newBuy.mark || newBuy.uid) && (
                                    <Col md={7} className={"mt-2"}>
                                        <Alert variant={"secondary"}>
                                            <span><strong>M.AR.K Παραστατικού:</strong> {newBuy.mark}</span><br/>
                                            {newBuy.uid && (
                                                <React.Fragment>
                                                    <span><strong>UID Παραστατικού:</strong> {newBuy.uid}</span><br/>
                                                </React.Fragment>
                                            )}
                                            {newBuy.authCode && (
                                                <React.Fragment>
                                                    <span><strong>Authentication Code Παραστατικού:</strong> {newBuy.authCode}</span><br/>
                                                </React.Fragment>
                                            )}
                                        </Alert>
                                    </Col>
                                )}
                                <Col md={2} className={"mt-2"}>
                                    {!isEmpty(aiDoc?.filePath) && (
                                        <Button size={"sm"} className={"mr-1"} onClick={() => onFileOpen(aiDoc)}>Προβολή Παραστατικού <FaFileInvoice size={18} /></Button>
                                    )}
                                    {!isEmpty(aiDoc?.myDataObject?.downloadingInvoiceUrl) && (
                                        <Button size={"sm"} className={"mr-1"} onClick={() => window.open(aiDoc.myDataObject.downloadingInvoiceUrl, "_blank")}>Προβολή Παραστατικού <FaFileInvoice size={18} /></Button>
                                    )}
                                    {(!isEmpty(aiDoc?.aiThoughts) && checkPermission("custom-admin", [])) && (
                                        <Button size={"sm"} className={"mr-1 mt-2"} onClick={() => setShowAiThoughtsModal(true)}>Συλλογισμός Primer AI <RiGeminiFill size={18} /></Button>
                                    )}
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <div className={"text-muted"}><i>Πίνακας Χαρακτηρισμών Ειδών</i></div>
                                <EditableTable
                                    tableName={"AI Module New Buy Product List"}
                                    invoiceType={newBuy.myDataType}
                                    key={incrKey}
                                    actionButtons={{
                                        print: false,
                                        delete: false,
                                        export: false,
                                        edit: false,
                                    }}
                                    columns={productTableColumns}
                                    disabled={true}
                                    onUpdate={productTableFunctions}
                                    data={newBuy.products}
                                    allowInsertRow={false}
                                    allowActions={false}
                                    allowToggleColumns={false}
                                    allowPrintResults={false}
                                />
                            </Row>
                            <Row className={"mb-3"}>
                                <Col md={6}>
                                    <Accordion defaultActiveKey={defaultOpenAnamorfosis ? "0" : ""}>
                                        <Accordion.Item eventKey={"0"}>
                                            <Accordion.Header>Πίνακας Αναμορφώσεων</Accordion.Header>
                                            <Accordion.Body>
                                                <EditableTable
                                                    tableName={"AI Module New Buy Anamorfosis"}
                                                    allowActions={false}
                                                    key={incrKey}
                                                    data={newBuy.products}
                                                    columns={buyAnamorfosisColumns}
                                                    onUpdate={productTableFunctions}
                                                    actionButtons={{
                                                        print: false,
                                                        delete: false,
                                                        export: false,
                                                        edit: false,
                                                    }}
                                                />
                                                <Row>
                                                    <Col md={4}></Col>
                                                    <Col md={8} className="d-flex justify-content-end align-items-center gap-3">
                                                        <div>
                                                            <span className="mb-1 d-block">Εφαρμογή ποσοστιαίας αναμόρφωσης</span>
                                                            <AccountingBox
                                                                name="percentageAnamorfosis"
                                                                suffix="%"
                                                                defaultValue={percentageAnamorfosis}
                                                                key={percentageAnamorfosis}
                                                                onBlur={(e) => {
                                                                    let val = +e.target.value;
                                                                    if (!val) val = 0;
                                                                    if (val > 100) val = 100;
                                                                    setPercentageAnamorfosis(val);
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <Button
                                                                size="sm"
                                                                onClick={() => {
                                                                    const cloneProducts = quickClone(newBuy.products);
                                                                    for (const p of cloneProducts) {
                                                                        p.anamorfosisNetValue = +(p.netValue * (percentageAnamorfosis / 100)).toFixed(2);
                                                                        p.anamorfosisVatValue = +(p.vat * (percentageAnamorfosis / 100)).toFixed(2);
                                                                        p.anamorfosisTaxValue = +((+p.taxes || 0) * (percentageAnamorfosis / 100)).toFixed(2);
                                                                        p.anamorfosiPercent = percentageAnamorfosis;
                                                                    }
                                                                    setNewBuy({...newBuy, products: cloneProducts});
                                                                }}
                                                            >
                                                                Εφαρμογή
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Col>
                                <Col md={6}>
                                    <Accordion defaultActiveKey={defaultOpenAssets ? "0" : ""}>
                                        <Accordion.Item eventKey={"0"}>
                                            <Accordion.Header>Πίνακας Παγίων</Accordion.Header>
                                            <Accordion.Body>
                                                <EditableTable
                                                    tableName={"AI Module New Buy Fixed Assets"}
                                                    allowActions={false}
                                                    key={incrKey}
                                                    data={newBuy.products}
                                                    columns={buyFixedAssetColumns}
                                                    onUpdate={productTableFunctions}
                                                    actionButtons={{
                                                        print: false,
                                                        delete: false,
                                                        export: false,
                                                        edit: false,
                                                    }}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row className="d-flex justify-content-end">
                                <Col md={8} style={{position: "inherit"}}>
                                    <EditableTable
                                        tableName={"AI Module New Buy Taxes Totals"}
                                        className="sales-taxes-calculations"
                                        allowActions={false}
                                        key={incrKey}
                                        data={fixDocumentTaxesDisplay(newBuy, "buys")}
                                        columns={buysTaxesColumns}
                                        actionButtons={{
                                            print: false,
                                            delete: false,
                                            export: false,
                                            edit: false,
                                        }}
                                    />
                                </Col>
                                <Col md={4}>
                                    <table className="table table-bordered mb-3">
                                        <tbody>
                                        <tr>
                                            <td className="fw-bold">Συνολική Ποσότητα</td>
                                            <td>{newBuy.totalQuantity}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Καθαρή Αξία</td>
                                            <td>{getGreekCurrencyFormat(newBuy.totalNetValue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Αξία Φ.Π.Α.</td>
                                            <td>{getGreekCurrencyFormat(newBuy.totalVatValue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Σύνολο Κρατήσεων</td>
                                            <td>{getGreekCurrencyFormat(newBuy.totalDeductions)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Σύνολο Φόρων</td>
                                            <td>{getGreekCurrencyFormat(newBuy.totalTaxesAmount)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Συνολική Αξία</td>
                                            <td>{getGreekCurrencyFormat(newBuy.totalAmount)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">Πληρωτέο Ποσό</td>
                                            <td>{getGreekCurrencyFormat(newBuy.paymentAmount)}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            {(moment(newBuy?.date).isValid() && !isEmpty(aiDoc.date) && moment(aiDoc.date, "DD/MM/YYYY").format("MM") !== moment(newBuy?.date).format("MM") && aiModuleType === "files") && (
                                <Alert style={{ padding: "0.5rem", marginBottom: "10px" }} variant="danger">
                                    <CgDanger size={25} />{" "}
                                    <span style={{fontWeight: "bold"}}>ΠΡΟΣΟΧΗ! Κατά την αποθήκευση της αγοράς το αρχείο θα μετακινηθεί στο φάκελο{" "}{greekMonths[moment(newBuy?.date).month()]}</span>
                                </Alert>
                            )}
                        </div>
                    ) : (
                        <React.Fragment></React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" className={"mr-1"} onClick={() => onDecline(aiDoc)}>
                        <MdOutlineCancel size={16} /> Απόρριψη
                    </Button>
                    <Button variant="primary" className={"mr-1"} onClick={() => onReprocess(aiDoc)}>
                        <TbReload size={16} /> Επαναεπεξεργασία
                    </Button>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onSave(aiDoc, newBuy, setLoadingSave)} disabled={loadingSave}>
                        Αποθήκευση {loadingSave && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <ChangeCategoryModal
                show={showChangeCategoryModal}
                setShow={setShowChangeCategoryModal}
                defaultRowData={selectedRowData}
                callbackFunction={(aiCategory) => {
                    const cloneProducts = quickClone(newBuy.products);
                    const idx = cloneProducts.findIndex((el) => el.no === selectedRowData.no);
                    if (idx >= 0) {
                        cloneProducts[idx].aiCategory = aiCategory;
                        setNewBuy({...newBuy, products: cloneProducts});
                    }
                }}
            />

            {showAiThoughtsModal && (
                <Modal show={showAiThoughtsModal} dialogClassName={"modal42PercentWidth"} onHide={() => setShowAiThoughtsModal(false)} backdrop={"static"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Συλλογισμός Primer AI</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert style={{whiteSpace: 'pre-wrap'}} variant={"secondary"}>
                            {aiDoc?.aiThoughts}
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowAiThoughtsModal(false)}>
                            Κλείσιμο
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </React.Fragment>
    )
}

export default AISaveBuyModal;
